import { seriesEsp, seriesEng, seriesId, groupsEsp, groupsEng } from './translations/translations_frp_contabilidad_crecimiento_espanya.js';
import { translateSeries } from '../lib/translate_series_name.js'
export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];
    this.setDefaults();

    return {
      charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
      ranges: this.RANGES_DEFAULT,
      endpoints: {
        series: this.series,
        data: {
          build: () => {
            const sql = 'select * from contabilidad_crecimiento_espana';
            const gobiertoPath = process.env.GOBIERTO_DATA_URL
            const token = process.env.GOBIERTO_DATA_TOKEN
            const query = `?sql=${sql}&token=${token}`;

            return `${gobiertoPath}/api/v1/data/data.json${query}`;
          },
          parse: data => {
            this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, null, null, groupsEsp, groupsEng)
            const series = this.series.map(d => ({
              id: d.id,
              name: d.name,
              units: d.units,
              group: d.group
            }));
            // reorder the return data to be grouped by kind of serie
            const groupBySerie = series.map(set =>
              data.data.map(d => ({
                serie: set.id,
                time: new Date(d["year"], 0, 1),
                value: parseFloat(d[set.id]),
                name: set.name,
                units: set.units,
                idTooltip: "ch",
                group: set.group
              }))
            );

            // give a flatted array
            return groupBySerie.flat();
          }
        }
      }
    };
  }

  setDefaults = () => {
    const series = [
      {
        "id": "c0_pibpm",
        "name": "PIBpm",
        "units": "2010=100",
        "group": "PIB en términos reales y su composición (2010=100)"
      },
      {
        "id": "c0_poblacion",
        "name": "Población",
        "units": "2010=100",
        "group": "PIB en términos reales y su composición (2010=100)"
      },
      {
        "id": "c0_pib_hora_trabajada",
        "name": "PIB/hora trabajada ",
        "units": "2010=100",
        "group": "PIB en términos reales y su composición (2010=100)"
      },
      {
        "id": "c0_horas_trabjadas_persona",
        "name": "Horas trabjadas/Persona",
        "units": "2010=100",
        "group": "PIB en términos reales y su composición (2010=100)"
      },
      {
        "id": "c1_horas_trabajadas_persona",
        "name": "Horas trabajadas/Persona",
        "units": "2010=100",
        "group": "Horas trabajadas por persona y su composición (2010=100)"
      },
      {
        "id": "c1_horas_trabajador_etc",
        "name": "Horas/trabajador ETC*",
        "units": "2010=100",
        "group": "Horas trabajadas por persona y su composición (2010=100)"
      },
      {
        "id": "c1_trabajador_etc_pet",
        "name": "Trabajador ETC/PET*",
        "units": "2010=100",
        "group": "Horas trabajadas por persona y su composición (2010=100)"
      },
      {
        "id": "c1_pet_poblacion",
        "name": "PET/Población",
        "units": "2010=100",
        "group": "Horas trabajadas por persona y su composición (2010=100)"
      },
      {
        "id": "c2_cantidad_de_trabajo",
        "name": "Cantidad de trabajo",
        "units": "2010=100",
        "group": "Input de trabajo y su composición (2010=100)"
      },
      {
        "id": "c2_calidad_del_trabajo_renta",
        "name": "Calidad del trabajo (renta)",
        "units": "2010=100",
        "group": "Input de trabajo y su composición (2010=100)"
      },
      {
        "id": "c2_input_de_trabajo_renta",
        "name": "Input de trabajo (renta)",
        "units": "2010=100",
        "group": "Input de trabajo y su composición (2010=100)"
      },
      {
        "id": "c2_calidad_del_trabajo_educacion",
        "name": "Calidad del trabajo (educación)",
        "units": "2010=100",
        "group": "Input de trabajo y su composición (2010=100)"
      },
      {
        "id": "c2_input_de_trabajo_educacion",
        "name": "Input de trabajo (educación)",
        "units": "2010=100",
        "group": "Input de trabajo y su composición (2010=100)"
      },
      {
        "id": "c3_capital",
        "name": "Capital",
        "units": "% PIB",
        "group": "Participación de los factores (% PIB)"
      },
      {
        "id": "c3_trabajo",
        "name": "Trabajo",
        "units": "% PIB",
        "group": "Participación de los factores (% PIB)"
      },
      {
        "id": "c3_tierra",
        "name": "Tierra",
        "units": "% PIB",
        "group": "Participación de los factores (% PIB)"
      },
      {
        "id": "c4_pib_hora_trabajada",
        "name": "PIB/hora trabajada",
        "units": "2010=100",
        "group": "El crecimiento del PIB por hora trabajada y sus determinantes (2010=100)"
      },
      {
        "id": "c4_input_de_capital_hora",
        "name": "Input de Capital/hora",
        "units": "2010=100",
        "group": "El crecimiento del PIB por hora trabajada y sus determinantes (2010=100)"
      },
      {
        "id": "c4_input_de_tierra_hora",
        "name": "Input de Tierra/hora",
        "units": "2010=100",
        "group": "El crecimiento del PIB por hora trabajada y sus determinantes (2010=100)"
      },
      {
        "id": "c4_calidad_del_trabajo_renta",
        "name": "Calidad del trabajo (Renta)",
        "units": "2010=100",
        "group": "El crecimiento del PIB por hora trabajada y sus determinantes (2010=100)"
      },
      {
        "id": "c4_productividad_total_de_los_factores_renta",
        "name": "Productividad Total de los Factores (Renta)",
        "units": "2010=100",
        "group": "El crecimiento del PIB por hora trabajada y sus determinantes (2010=100)"
      },
      {
        "id": "c4_calidad_del_trabajo_educacion",
        "name": "Calidad del trabajo (Educación)",
        "units": "2010=100",
        "group": "El crecimiento del PIB por hora trabajada y sus determinantes (2010=100)"
      },
      {
        "id": "c4_productividad_total_de_los_factores_educacion",
        "name": "Productividad Total de los Factores (Educación)",
        "units": "2010=100",
        "group": "El crecimiento del PIB por hora trabajada y sus determinantes (2010=100)"
      }
    ];

    if (this.charts[0].group) {
      const arrayOfGroup = this.charts[0].group
      this.series = series.filter((d) => arrayOfGroup.includes(d.group))
    } else {
      this.series = series
    }

    const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    this.RANGES_DEFAULT = range(1850, 2023);

    this.CHARTS_DEFAULT = [
      {
        type: "Line",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        bspline: false,
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      },
      {
        type: "Stacked",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      }
    ];
  };
  getScale(key, d3) {
    const scales = {
      linear: d3.scaleLinear(),
      log: d3.scaleLog(),
      pow: d3.scalePow()
    };

    if (scales.hasOwnProperty(key)) {
      return scales[key];
    } else {
      return scales[0];
    }
  }
}
